import { param } from "jquery";
import axios from "./axios-auth";

const insertTransactionReport = (data, params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/gettransactionreport",
      params: params,
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, " from insert transaction report api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from insert transaction report api");
      });
  });

const insertTransactionReportExcel = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/gettransactionreport",
      params: {
        pg_num: 1,
        pg_size: 10,
      },
      data: payload.form,
      method: "POST",
      timeout: 60000,
    })
      .then((resp) => {
        console.log(resp, " from insert transaction report excel api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from insert transaction report excel api");
      });
  });

const getUserCodes = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/getusercodes",
      params: {},
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, " from get user codes api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from get user codes api");
      });
  });

const getTransactionReport = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/gettransactionreportbyuserid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, " from get user codes api");
        resolve(resp);
      })
      .catch((err) => {
        console.log(err, "from get user codes api");
      });
  });

  const getSumTransaction = async (params) => {
    try {
    const resp = await axios.post("hr-adm/getsumtransactions", params)
    return resp
    }
    catch (e) {
      return e
    }
  };

export {
  insertTransactionReport,
  insertTransactionReportExcel,
  getUserCodes,
  getTransactionReport,
  getSumTransaction
};
